interface SendingDraftCandidate {
  id: unknown;
  supportTicketId: unknown;
  status: unknown;
  threadId: unknown;
}

export function sendingDraftIdsForMessageCreated(input: {
  drafts: Iterable<SendingDraftCandidate>;
  supportTicketId: unknown;
  channelThreadId: unknown;
}): string[] {
  const supportTicketId = String(input.supportTicketId);
  const channelThreadId = String(input.channelThreadId);

  return [...input.drafts]
    .filter(
      (draft) =>
        String(draft.supportTicketId) === supportTicketId &&
        draft.status === "SENDING" &&
        String(draft.threadId) === channelThreadId,
    )
    .map((draft) => String(draft.id));
}
